import React from "react";
import { makeStyles, Grid, Typography } from "@material-ui/core";
import "./styles.css";
import TypeTest from "./TypeTest/TypeTest";
import HeaderText from "./Components/HeaderText";

const useStyles = makeStyles(theme => ({
  root: {
    background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    maxWidth: "100%",
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  mobileWarning: {
    margin: 0,
    backgroundColor: theme.palette.primary.light,
    color: "white",
    padding: theme.spacing(),
    height: "100vh",
    width: "100vw",
    maxWidth: "100%",
    flexGrow: 1,
    [theme.breakpoints.up("xs")]: {
      display: "none"
    },
    [theme.breakpoints.down("xs")]: {
      display: "flex"
    }
  },
  top: {
    height: "50vh"
  },
  down: {
    height: "50vh"
  }
}));

export default function App() {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.root}>
        <Grid container direction="column" justify="center">
          <Grid item align="center" className={classes.top}>
            <HeaderText />
          </Grid>
          <Grid item className={classes.down}>
            <TypeTest />
          </Grid>
        </Grid>
      </div>

      <Grid
        container
        direction="column"
        alignItems="center"
        alignContent="center"
        justify="center"
        className={classes.mobileWarning}
        spacing={2}
      >
        <Grid item>
          <Typography variant="h2">Recruiter Type Test</Typography>
        </Grid>
        <Grid item>
          <Typography variant="subtitle2">
            Please open this app on a larger screen to play Reacruiter Type Test
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}
